import { useState } from "react";

import { postTrackingData } from "@/api/endpoints/track";
import { useEpisode } from "@/containers/Episode/context";
import { getShowName } from "@/containers/Episode/utils/getShowName";
import SourceDisplay from "@/containers/SourceDisplay";
import { EVENT } from "@/tracking_events";
import { isSourceWithTitle, pluralize } from "@/utils";
import ExpandDescription from "@components/ExpandDescription";
import Typography from "@components/Typography";

import styles from "./Header.module.css";

const Header = (props) => {
  const {
    website_url,
    show,
    title,
    episode_public_url,
    source,
    external_source,
    mentions,
    trimmed_description_mention,
    description_mention,
    episodeNameMentions,
    title_mention,
    channelTitleMentions,
  } = useEpisode();

  const [showFullDescription, setShowFullDescription] = useState(false);

  // Update this to use a property that includes all the mentions
  const mentionsCount = mentions?.length;

  const track = (context) => {
    postTrackingData(EVENT.EXTERNAL_URL_CLICK, {
      url: props.share_url,
      source: props.audio_url,
      context,
    });
  };

  return (
    <div className={styles.root} {...props}>
      <div className={styles.sourceDisplayWrapper}>
        <SourceDisplay
          title={title}
          source={source}
          external_source={external_source}
        />
        {mentionsCount ? (
          <Typography
            className={styles.mentionCounter}
            variant="caption"
            data-testid="mentions-counter"
          >
            • {mentionsCount}{" "}
            {pluralize(
              mentionsCount,
              L.MENTIONS_VIEW_MENTIONS_COUNT_SINGULAR,
              L.MENTIONS_VIEW_MENTIONS_COUNT_PLURAL
            )}
          </Typography>
        ) : null}
      </div>

      <Typography
        block
        className="highlight-match"
        data-testid="show-title"
        variant="subtitle-1"
        {...(website_url
          ? {
              component: "a",
              href: website_url,
              target: "_blank",
              rel: "noreferrer",
              onClick: () => track("show"),
            }
          : {})}
        dangerouslySetInnerHTML={{
          __html: getShowName({
            show:
              channelTitleMentions.length > 0
                ? channelTitleMentions[0].content
                : show,
            source,
          }),
        }}
      />

      {isSourceWithTitle(source) ? (
        episode_public_url ? (
          <Typography
            block
            data-testid="episode-title"
            variant="h4"
            className="highlight-match"
            component="a"
            onClick={() => track("audio url")}
            href={episode_public_url}
            target="_blank"
            rel="noreferrer"
            {...(title_mention
              ? {
                  dangerouslySetInnerHTML: {
                    __html: title_mention,
                  },
                }
              : { children: title })}
          />
        ) : (
          <Typography
            block
            data-testid="episode-title"
            className="highlight-match"
            variant="h4"
            component="span"
            rel="noreferrer"
            {...(episodeNameMentions.length
              ? {
                  dangerouslySetInnerHTML: {
                    __html: episodeNameMentions[0].content,
                  },
                }
              : { children: title })}
          />
        )
      ) : null}

      {description_mention && (
        <>
          <Typography
            component="span"
            data-testid="episode-description"
            className="highlight-match"
            dangerouslySetInnerHTML={{
              __html: showFullDescription
                ? description_mention
                : trimmed_description_mention,
            }}
          />

          {trimmed_description_mention &&
            description_mention.length > trimmed_description_mention.length && (
              <ExpandDescription
                showFullDescription={showFullDescription}
                onClick={() => setShowFullDescription(!showFullDescription)}
              />
            )}
        </>
      )}
    </div>
  );
};

export default Header;
